import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import Tabla from './Tabla';
import CodeContent from './CodeContent';
import TablaTipoComprobante from './TablaTipoComprobante';

function createData(
  campo,
  Tipo,
  valorEjemplo,
  Descripcion
) {
  return { campo, Tipo, valorEjemplo, Descripcion };
}
const Movimiento = () => {
  const [t] = useTranslation('global');
  
  const rows = [
    createData("TipoDocumentoCodigo", "String", "01", t('content.movimientoDetalle.TipoDocumentoCodigo') ),
    createData("Serie", "String", "F001",t('content.movimientoDetalle.Serie')),
    createData("Correlativo", "Int", "1",t('content.movimientoDetalle.Correlativo')),
    createData("Condicion", "String", "Contado",t('content.movimientoDetalle.Condicion')),
    createData("CondicionComprobante", "String", "Contado",t('content.movimientoDetalle.CondicionComprobante')),
    createData("TipoCuentaCodigo", "Int", "1",t('content.movimientoDetalle.TipoCuentaCodigo')),
    createData("CuentaNumero", "String", "10101010",t('content.movimientoDetalle.CuentaNumero')),
    createData("Usuario", "String", "10101010",t('content.movimientoDetalle.Usuario')),
    createData("MonedaCodigo", "String", "PEN",t('content.movimientoDetalle.MonedaCodigo')),
    createData("SucursalId", "Int", "1",t('content.movimientoDetalle.SucursalId')),
    createData("TipoDocIdentidadCodigo", "String", "1",t('content.movimientoDetalle.TipoDocIdentidadCodigo')),
    createData("NumeroDocIdentidad", "String", "45454545",t('content.movimientoDetalle.NumeroDocIdentidad')),
    createData("Observacion", "String", "Ventas",t('content.movimientoDetalle.Observacion')),
    createData("CuentaNombre", "String", "BCP",t('content.movimientoDetalle.CuentaNombre')),
    createData("CuentaValor", "String", "1-10101010", t('content.movimientoDetalle.CuentaValor')), 
    createData("Pago", "Decimal", "100.00", t('content.movimientoDetalle.Pago')),
    createData("Vuelto", "Decimal", "10.00", t('content.movimientoDetalle.Vuelto')),
    createData("FechaPago", "DateTime", "08/02/2023", t('content.movimientoDetalle.FechaPago')),
    createData("NumeroOperacion", "String", "0455120", t('content.movimientoDetalle.NumeroOperacion')),
    createData("FechaVencimiento", "DateTime", "08/03/2023", t('content.movimientoDetalle.FechaVencimiento')),
    createData("PlazoDias", "Int", "30", t('content.movimientoDetalle.PlazoDias'))
   ];

  const datos =
    `
    {
      "TipoDocumentoCodigo": "01",
      "Serie": "F001",
      "Correlativo": 1,
      "Condicion": "Contado",
      "CondicionComprobante": "Contado",
      "TipoCuentaCodigo": 1,
      "CuentaNumero": "10101010",
      "Usuario": "10101010",
      "MonedaCodigo": "PEN",
      "SucursalId": 1,
      "TipoDocIdentidadCodigo": 1,
      "NumeroDocIdentidad": "45454545",
      "Observacion": "Ventas",
      "CuentaNombre": "BCP",
      "CuentaValor": "1-10101010",
      "Pago": 100.00,
      "Vuelto": 10.00,
      "FechaPago": "08/04/2026",
      "NumeroOperacion": "0455120",
      "FechaVencimiento": "08/04/2026",
      "PlazoDias": 30
    }
    ` 
  ;
  const respuestaFactura =
  `
  {
    "xml_pdf": {
        "IDComprobante": 92869,
        "Codigo": 0,
        "IDRepositorio": "zLEExc3lbkCwIHcvtuP2JA==",
        "Firma": "nLpw2MXleQkyw/223CVZTOvqUQ0=",
        "Mensaje": "01-F002-1916"
    },
    "cdr": {
        "IDComprobante": 92869,
        "Codigo": 0,
        "IDRepositorio": "19001164",
        "Firma": "",
        "Mensaje": "La Factura numero F002-1916, ha sido aceptada"
      }
  }       
  `
;
const respuestaBoleta =
  `
  {
    "xml_pdf": {
        "IDComprobante": 92865,
        "Codigo": 0,
        "IDRepositorio": "SspjOsVXeHELV0s1yaRbWA==",
        "Firma": "2Yol66hI6dfH3Tb9rboKcCQruPw=",
        "Mensaje": "03-B001-5068"
    },
    "cdr": {
        "IDComprobante": 92865,
        "Codigo": 0,
        "IDRepositorio": "19005261",
        "Firma": "",
        "Mensaje": "La Boleta numero B001-5068, ha sido aceptada"
    }
  }
  `
;
const respuestaNotaCredito =
  `
  {
    "xml_pdf": {
        "IDComprobante": 92883,
        "Codigo": 0,
        "IDRepositorio": "jFquFm7dclZN+Rruzckx6A==",
        "Firma": "p05W/m+XXnwvxTe+JE3pFcMWfig=",
        "Mensaje": "07-FC01-1133"
    },
    "cdr": {
        "IDComprobante": 92883,
        "Codigo": 0,
        "IDRepositorio": "19005277",
        "Firma": "",
        "Mensaje": "La Nota de Credito numero FC01-1133, ha sido aceptada"
    }
  }
  
  `
;
const respuestaNotaDebito =
  `
  {
    "xml_pdf": {
        "IDComprobante": 92884,
        "Codigo": 0,
        "IDRepositorio": "IrkEoS/xXN9nRu8DbjJvfw==",
        "Firma": "sV3TL8VnYRPyEvIZb9MHcnwjopY=",
        "Mensaje": "08-FD01-101"
    },
    "cdr": {
        "IDComprobante": 92884,
        "Codigo": 0,
        "IDRepositorio": "19005278",
        "Firma": "",
        "Mensaje": "La Nota de Debito numero FD01-101, ha sido aceptada"
    }
  }
  
  `
;
  return (
    <div id='movimiento'>
      <Divider sx={{ height: '70px' }} />
      <Typography variant="h3" id={"movimientoObjeto"} gutterBottom>
        {t('content.movimiento.titulo')}
      </Typography>
      <Typography variant="h5" gutterBottom>
        {t('content.movimiento.subtituloObjeto')}
      </Typography>
      <CodeContent code={datos} />
      <br id={"movimientoDescripcion"}/>
      <br/>
      <br/>
      <Typography variant="h5" gutterBottom>
        {t('content.movimiento.subtituloTabla')}
      </Typography>
      <Tabla rows={rows}/>
      <br/>
      <Typography variant="h5" gutterBottom>
        {t('content.notaCredito.subtituloRespuesta')}
      </Typography>
      <Typography variant="body1" id="NotaCredito" gutterBottom>
        {t('content.notaCredito.respuesta')}
      </Typography>
      <TablaTipoComprobante Factura={respuestaFactura} NombreFactura={t('content.factura.titulo')} Boleta={respuestaBoleta} NombreBoleta={t('content.boleta.titulo')} NotaCredito={respuestaNotaCredito} NombreNotaCredito={t('content.notaCredito.titulo')} NotaDebito={respuestaNotaDebito} NombreNotaDebito={t('content.notaDebito.titulo')}></TablaTipoComprobante>
    </div>
  );
}
export default Movimiento